import { ChangeEventHandler, FC, useRef } from "react";
import { Box, Button } from "@mui/material";
import { FileDownloadOutlined, FileUploadOutlined } from "@mui/icons-material";
import { AppConstant } from "@/const";

type InternalActionsProps = {
  onExport: () => void;
  onUpload: (file: File[]) => void;
};

const HIDDEN_INPUT_ID: string = "file-upload";

const InternalActions: FC<InternalActionsProps> = ({ onUpload, onExport }) => {
  const importInputRef = useRef<HTMLInputElement>(null);

  const handleChangeFile: ChangeEventHandler<HTMLInputElement> = event => {
    const fileList = event.target.files;
    const files = fileList ? Array.from(fileList) : [];
    if (onUpload && fileList) onUpload(files);
    if (importInputRef.current) importInputRef.current.value = "";
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "right", gap: 2 }}>
      <Button variant="contained" startIcon={<FileDownloadOutlined />} onClick={onExport}>
        Export
      </Button>

      <Button component="label" variant="contained" startIcon={<FileUploadOutlined />}>
        Import
        <input
          type="file"
          hidden
          ref={importInputRef}
          id={HIDDEN_INPUT_ID}
          onChange={handleChangeFile}
          accept={AppConstant.ACCEPT_ZIP_TYPE.join(",")}
          multiple
        />
      </Button>
    </Box>
  );
};

export default InternalActions;
